import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import styles from './App.styles';
import { IntlProvider } from 'react-intl';
import axios from 'axios';
import translations from './i18n/locales';
import KioskLayout from './components/Kiosk/KioskLayout';
import KioskPickupLayout from './components/KioskPickup/KioskPickupLayout';
import KioskVerifyMeLayout from './components/KioskVerifyMe/KioskVerifyMeLayout';
import KioskConfimPickupLayout from './components/KioskConfimPickup/KioskConfimPickupLayout';
import KioskSignatureMain from './components/KioskSignature/KioskSignatureMain';
import KioskConsultLayout from './components/KioskConsult/KioskConsultLayout';
import KioskFeedbackLayout from './components/KioskFeedback/KioskFeedbackLayout';
import KioskDoorLayout from './components/KioskDoor/KioskDoorLayout';
import KioskCollectIDLayout from './components/KioskCollenctID/KioskCollectIDLayout';
import KioskEnrollmentLayout from './components/KioskEnrollment/KioskEnrollmentLayout';
import AdminLoginLayout from './components/AdminLogin/AdminLoginLayout';
import AdminPanelLayout from './components/AdminPanel/AdminPanelLayout';
import AdminPanelStockLayout from './components/AdminPanelStock/AdminPanelStockLayout';
import AdminKioskVerifyLayout from './components/KioskVerify/AdminKioskVerifyLayout';
import AdminMaintenanceLayout from './components/AdminMaintenance/AdminMaintenanceLayout';
import AdminSettingLayout from './components/AdminSetting/AdminSettingLayout';
import LoginLayout from './components/Login/LoginLayout';
import { initialSettings } from './reducers/data';
import {
  startPolling,
  stopPolling,
  updatePollingStats,
  updateData,
  initialData
} from './api/common/actions';
import AdminRemoveLayout from './components/AdminRemove/AdminRemoveLayout';

//In wall Rear Stock

import RearStockAdminLoginLayout from './components/InWallRearStock/AdminLogin/AdminLoginLayout';
import RearStockAdminPanelLayout from './components/InWallRearStock/AdminPanel/AdminPanelLayout';
import RearStockAdminPanelStockLayout from './components/InWallRearStock/AdminPanelStock/AdminPanelStockLayout';
import RearStockAdminMaintenanceLayout from './components/InWallRearStock/AdminMaintenance/AdminMaintenanceLayout';
import RearStockAdminSettingLayout from './components/InWallRearStock/AdminSetting/AdminSettingLayout';
import RearStockAdminRemoveLayout from './components/InWallRearStock/AdminRemove/AdminRemoveLayout';
import RearStockAdminKioskVerifyLayout from './components/InWallRearStock/KioskVerify/AdminKioskVerifyLayout';
import { writeInitSettings, readSettings } from './helpers/board';
let FileObje = {
  boxId: '',
  dynamicDataSource: false,
  rearStock: false,
  IsActive: true
};
class App extends React.Component {
  componentWillMount() {
    writeInitSettings(FileObje);
    this.startPolling();
    // localStorage.setItem(
    //   'rearStock',
    //   false /*process.env.REACT_APP_REAR_STOCK*/
    // );
  }

  getBoxesData = () => {
    let boxId, dataSource;
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      boxId = fileData ? fileData.boxId : '';
      dataSource = fileData ? fileData.dynamicDataSource : false;
    } else {
      boxId = localStorage.getItem('boxId');
      dataSource = JSON.parse(localStorage.getItem('dynamicDataSource'));
    }

    if (dataSource === false || dataSource === null) {
      this.props.initialData(initialSettings);
      return true;
    } else {
      if (boxId) {
        return axios.get(
          process.env.REACT_APP_BASEURL + 'getprescriptions/' + boxId
        );
      } else {
        return axios.get(
          process.env.REACT_APP_BASEURL + 'getprescriptions/' + null
        );
      }
    }
  };

  getUpdatedBoxes = response => {
    if (response && response.data) {
      this.props.updateData(response.data);
      return true;
    }
    return false;
  };

  handleStatsChange = stats => {
    this.props.updatePollingStats(stats);
  };

  startPolling = () => {
    this.props.startPolling({
      asyncFetch: this.getBoxesData,
      callback: this.getUpdatedBoxes,
      onStatsChange: this.handleStatsChange,
      delay: 10,
      retryOnFailure: true,
      retryAfter: 5,
      stopAfterRetries: 50
    });
  };

  stopPolling = () => {
    this.props.updatePollingStats({});
    this.props.stopPolling();
  };

  render() {
    const { locale } = this.props;
    const localeKey = locale || 'en';
    const messages = translations[localeKey];

    return (
      <IntlProvider locale={localeKey} key={localeKey} messages={messages}>
        <div>
          <Switch>
            <Route path="/" exact component={KioskLayout} />
            <Route path="/KioskPickupCode" component={KioskPickupLayout} />
            <Route path="/KioskVerify" component={KioskVerifyMeLayout} />
            <Route
              path="/KioskConfirmPickup"
              component={KioskConfimPickupLayout}
            />
            <Route path="/KioskSignature" component={KioskSignatureMain} />
            <Route path="/KioskConsult" component={KioskConsultLayout} />
            <Route path="/KioskFeedback" component={KioskFeedbackLayout} />
            <Route path="/KioskCollectMedicines" component={KioskDoorLayout} />
            <Route path="/KioskConfirmUser" component={KioskCollectIDLayout} />
            <Route path="/KioskEnrollment" component={KioskEnrollmentLayout} />
            <Route path="/AdminLogin" component={AdminLoginLayout} />
            <Route path="/AdminPanel" component={AdminPanelLayout} />
            <Route path="/login" component={LoginLayout} />
            <Route path="/AdminStock" component={AdminPanelStockLayout} />
            <Route
              path="/AdminKioskVerify"
              component={AdminKioskVerifyLayout}
            />
            <Route
              path="/AdminMaintenance"
              component={AdminMaintenanceLayout}
            />
            <Route path="/AdminSettings" component={AdminSettingLayout} />
            <Route path="/AdminRemove" component={AdminRemoveLayout} />

            <Route
              path="/RearStock/AdminLogin"
              component={RearStockAdminLoginLayout}
            />
            <Route
              path="/RearStock/AdminStock"
              component={RearStockAdminPanelStockLayout}
            />
            <Route
              path="/RearStock/AdminPanel"
              component={RearStockAdminPanelLayout}
            />
            <Route
              path="/RearStock/AdminMaintenance"
              component={RearStockAdminMaintenanceLayout}
            />
            <Route
              path="/RearStock/AdminSettings"
              component={RearStockAdminSettingLayout}
            />
            <Route
              path="/RearStock/AdminRemove"
              component={RearStockAdminRemoveLayout}
            />
            <Route
              path="/RearStock/AdminKioskVerify"
              component={RearStockAdminKioskVerifyLayout}
            />
          </Switch>
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = ({ box, pollingStats }) => ({
  box,
  ...pollingStats
});

const mapDispatchToProps = dispatch => ({
  startPolling: params => dispatch(startPolling(params)),
  stopPolling: () => dispatch(stopPolling()),
  updatePollingStats: stats => dispatch(updatePollingStats(stats)),
  updateData: box => dispatch(updateData(box)),
  initialData: box => dispatch(initialData(box))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(App));

// export default withStyles(styles, { withTheme: true })(App);
